import React from 'react';
import CommentsResume from './CommentsResume';

const SummaryPanel = ({ analysis, comments, videoMetadata, activeTab, setActiveTab }) => {
  if (!analysis) return null;

  // Get resume from analysis (could be resume or commentsResume for backward compatibility)
  const resume = analysis.resume || analysis.commentsResume;

  return (
    <div className="mb-8">
      {resume && (
        <CommentsResume resume={resume} />
      )}
    </div>
  );
};

export default SummaryPanel;
